
export type GetNotificationSettings200TypeSettings = {[key: string]: boolean};
